module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/settings-4-829efb561474501cc79487164292fb0c.svg";